import type { FaireProductEntity } from "../../entity_types/product";

export const p_zdec2j3n6j: FaireProductEntity = {
  token: "p_zdec2j3n6j",
  type: "product",
  name: "Aurise 18K Gold Non-Tarnish Freshwater Pearl Cross Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl: "https://cdn.faire.com/fastly/765cc26fdfa27699fee8c3993f09dc887b67f1dddaa1f2db2c67c1fe6d0d3af5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98eb059931735741a42b0f6214b2cf3d8ada89c9eb79e0e3d2ac2b1f56418130.jpeg",
    "https://cdn.faire.com/fastly/4a0b4f461d20afa31c9a333db5b2e4b65998028197de5f4d3fd12f5ab6ee5ca4.jpeg",
    "https://cdn.faire.com/fastly/1b8e4052393f2bfaa6f475169ac871f24c11c9cfe03b5adcd166c1d10f9ee7c8.jpeg"
  ],
  priceDollars: 17.85,
  description: "18K Gold Non-Tarnish Freshwater Pearl Cross Necklace\n18K Gold Plating\nStainless Steel\nCultured Pearl\nPendant Size (inch): 1.48\nChain Length (inch): 16.53\nChain Length (inch): 17.71\nExtension(inch): 2\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:14.014Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
